export default __webpack_public_path__ + "static/media/currency.fc5945a6.svg";